import { cn } from '@/lib/utils';

const ReleaseItemList = ({ items, selectedId, onSelect, renderItem, emptyMessage = 'No items available' }) => {
  if (!items.length) {
    return (
      <div className="text-center text-gray-400 py-8">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {items.map((item) => (
        <button
          key={item.id}
          className={cn(
            'w-full text-left p-3 rounded-md border transition-colors cursor-pointer',
            selectedId === item.id
              ? 'border-primary bg-primary/5 ring-1 ring-primary'
              : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
          )}
          onClick={() => onSelect(item.id)}
          type="button"
        >
          {renderItem(item)}
        </button>
      ))}
    </div>
  );
};

export default ReleaseItemList;
